import { axiosPrivate } from "../api/axios";
import useAuth from '../hooks/useAuth'




//Interceptar las solicitudes privadas de axios
axiosPrivate.interceptors.request.use(function (config) {
    if(window.sessionStorage.getItem('accessToken')){
        const token=(window.sessionStorage.getItem('accessToken'))
        config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    }
}); 


export default axiosPrivate;




